import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DeviceWrapper from '../../Shared/DeviceWrapper';
import editStructure from '../../../Utils/editStructure';
import StructuresSelect from '../../Shared/StructuresSelect';
import SaveFab from '../../Shared/SaveFab';
import renderFromStructure from '../../../Utils/renderFromStructure';
import findUnknownElement from '../../../Utils/findUnknownElement';
import ContentError from '../../../../../Components/Error/ContentError';
import { useIntl } from 'react-intl';
import { FullSizeCenteredColumn } from '../../../../../Components/FlexBox';
import encodeBase64 from '../../../../../Helpers/encode';

const styles = {
  emailTableWrap: {
    width: '100%',
    maxWidth: '600px',
    margin: 'auto',
    height: '100%',
    background: 'rgb(255, 255, 255)',
    color: '#111',
    borderRadius: '25px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
};

const EmailTemplateContent = function EmailTemplateContent({
  template = null,
  handleSave = () => {},
  handleEditTemplateList = () => {},
  dynamicElement = '',
}) {
  const intl = useIntl();
  const [enableSaving, setEnableSaving] = useState(false);
  const unknown = template?.structure
    ? findUnknownElement(template.structure)
    : null;

  const onChangeTemplateBody = (elementToEdit) => {
    handleEditTemplateList({
      ...template,
      structure: [...editStructure(elementToEdit, template?.structure)],
    });
    setEnableSaving(true);
  };

  const handleSelectStructure = ({ body: structure }) => {
    handleEditTemplateList({
      ...template,
      structure,
    });
  };

  const handleSaveTemplate = () => {
    const content = document.getElementById('content-to-send').innerHTML; //gets the innerHTML from  the hidden div

    handleSave({
      ...template,
      content: encodeBase64(content),
      structure: encodeBase64(JSON.stringify(template?.structure)),
      outcomes: template?.outcomes,
    });
  };

  return template?.isNew && !template?.structure ? (
    <StructuresSelect
      scope="EMAIL"
      handleSelectStructure={handleSelectStructure}
    />
  ) : (
    <>
      <DeviceWrapper device="DESKTOP" templateName={template?.name}>
        {template?.structure && !unknown ? (
          <table id="email-wrapper" style={styles.emailTableWrap}>
            <tbody>
              {renderFromStructure({
                element: template?.structure,
                onChange: onChangeTemplateBody,
                name: template?.name,
                inEdit: true,
                forEmail: true,
                dynamicElement,
              })}
            </tbody>
          </table>
        ) : (
          <FullSizeCenteredColumn>
            <ContentError
              text={intl.messages.TEMPLATE_NOT_EDITABLE}
              message={
                unknown &&
                intl.formatMessage(
                  { id: 'UNKNOWN_TEMPLATE_ELEMENT' },
                  { type: unknown.type, position: unknown.path.join(' › ') }
                )
              }
            />
          </FullSizeCenteredColumn>
        )}
      </DeviceWrapper>
      {!unknown && (
        <SaveFab enableSaving={enableSaving} handleSave={handleSaveTemplate} />
      )}
      {template?.structure && !unknown && (
        <div id="content-to-send" style={{ display: 'none' }}>
          <table id="email-table" style={styles.emailTableWrap}>
            <tbody>
              {renderFromStructure({
                element: template?.structure,
                name: template?.name,
                inEdit: false,
                forEmail: true,
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

EmailTemplateContent.propTypes = {
  template: PropTypes.object,
  handleEditTemplateList: PropTypes.func,
  handleSave: PropTypes.func,
  dynamicElement: PropTypes.string,
};
export default EmailTemplateContent;
